import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";

import { QuickAction } from "../types";

interface ActionTypeContext {
  actionType: QuickAction | undefined;
}

const INITIAL_STATE: ActionTypeContext = {
  actionType: undefined,
};

const {
  useStore: useActionTypeContextStore,
  Provider: ActionTypeContextProvider,
} = createContextStore<ActionTypeContext>(INITIAL_STATE);

export { ActionTypeContextProvider, useActionTypeContextStore };
